export const transformAtomDateToApiDateTime = (date: string): string => date.split('+')[0]
